import { useTheme } from "arkh";
import Color from "color";
import { useMemo } from "react";

export function useBackgroundColor(color: string | null) {
  const theme = useTheme();
  const backgroundColor = useMemo(
    () =>
      Color(color ?? theme.primary)
        .mix(Color("#FFF"), 0.92)
        .toString(),
    [color, theme.primary]
  );
  return backgroundColor;
}
